import { courseProgressActions } from './courseProgressSlice'
import { fetchHelper } from '../../../api/api'
import { getErrorMessage } from '../../../util/functions'

export const getCourseProgress = classId => async dispatch => {
    dispatch(courseProgressActions.getCourseProgressRequest())
    try {
        const response = await fetchHelper.get(
            `/CourseProgress/GetClassProgress/${classId}`
        )
        const { percentageCompleted, items } = response.data
        dispatch(
            courseProgressActions.getCourseProgressRequestSuccess({
                percentageCompleted,
                items,
            })
        )
    } catch (e) {
        dispatch(
            courseProgressActions.getCourseProgressRequestFailure(
                getErrorMessage(e)
            )
        )
    }
}

export const markTopicAsDone = ({ classId, topicId }) => async dispatch => {
    await fetchHelper.patch(
        `/CourseProgress/MarkTopicAsDone/${classId}/${topicId}`
    )
    dispatch(courseProgressActions.markTopicDone(topicId))
}

export const setTopicAsCurrent = ({ classId, topicId }) => async dispatch => {
    await fetchHelper.patch(
        `/CourseProgress/SetTopicAsCurrent/${classId}/${topicId}`
    )
    dispatch(courseProgressActions.markTopicDone(topicId))
}

export async function getProgressPercentage(classId) {
    const response = await fetchHelper.get(
        `/CourseProgress/GetProgressPercentage/${classId}`
    )
    return response.data
}
